import React from 'react';
import { useTranslation } from 'react-i18next';
import Fade from 'react-reveal/Fade';

// import MianAppBar from '../../components/main-app-bar/MianAppBar';
import './PayPage.scss';
import PayForm from './PayForm';

import pay from '../../assets/imgs/bgs/pay.png';

const PayPage = () => {
  const { i18n } = useTranslation();
  return (
    <Fade delay={50}>
      <>
        {/* <MianAppBar /> */}
        <div className={`pay-section ${i18n.dir()}`}>
          <div className="custom-container">
            <div className="main-wrapper">
              <div className="hero-img">
                <img src={pay} alt="pay" />
              </div>

              <div className="hero-text">
                <PayForm />
              </div>
            </div>
            <div className="hero-footer"></div>
          </div>
        </div>
      </>
    </Fade>
  );
};

export default PayPage;
